var map = {
	"./decidim/avatar-multiuser.png": 16267,
	"./decidim/brands/google.svg": 33690,
	"./decidim/cc-badge.png": 42841,
	"./decidim/decidim-logo.svg": 35257,
	"./decidim/default-avatar.svg": 28873,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 19119,
	"./decidim/icons.svg": 95176,
	"./decidim/pattern.png": 35963,
	"./decidim/placeholder-card-g.svg": 28488,
	"./decidim/placeholder-card-l.svg": 16867,
	"./decidim/placeholder.jpg": 6986,
	"./decidim/remixicon.symbol.svg": 58576,
	"./decidim/vendor/leaflet/layers-2x.png": 82582,
	"./decidim/vendor/leaflet/layers.png": 41056,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 40401,
	"./decidim/vendor/leaflet/marker-icon.png": 76888,
	"./decidim/vendor/leaflet/marker-shadow.png": 4999,
	"./decidim/vendor/social-share-button/douban.svg": 38851,
	"./decidim/vendor/social-share-button/email.svg": 73916,
	"./decidim/vendor/social-share-button/facebook.svg": 98024,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 23276,
	"./decidim/vendor/social-share-button/hacker_news.svg": 8560,
	"./decidim/vendor/social-share-button/linkedin.svg": 97306,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 82915,
	"./decidim/vendor/social-share-button/pinterest.svg": 2698,
	"./decidim/vendor/social-share-button/reddit.svg": 61472,
	"./decidim/vendor/social-share-button/telegram.svg": 64421,
	"./decidim/vendor/social-share-button/tumblr.svg": 12514,
	"./decidim/vendor/social-share-button/twitter.svg": 87801,
	"./decidim/vendor/social-share-button/vkontakte.svg": 24147,
	"./decidim/vendor/social-share-button/wechat.svg": 93566,
	"./decidim/vendor/social-share-button/whatsapp.svg": 11830,
	"./decidim/vendor/social-share-button/x.svg": 60212,
	"./decidim/vendor/social-share-button/xing.svg": 49700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80426;